module.exports = __webpack_public_path__ + "img/Weapon_290.30a3b7f7.png";